<template>
  <page-status class="insure-result" :loading="loading">
    <page-result
      v-if="detail.totalPremium"
      :image="imgSuccess"
      title="支付成功"
      desc="稍后会以短信的形式为您推送电子保单查询入口。请耐心等待，注意查收。"
    >
      <div class="result-pay">
        <div class="header">
          <span class="header-title">车险投保</span>
          <span class="header-premium">{{ detail.totalPremium }}元</span>
        </div>
        <div class="split-line"></div>
        <div class="content">
          <div class="content-item">
            车牌号：{{ detail.licenseNo || '新车未上牌' }}
          </div>
          <div class="content-item">车架号：{{ detail.frameNo }}</div>
          <div class="content-item">投保人：{{ detail.appliName }}</div>
        </div>
      </div>
      <div class="result-qrcode" v-if="businessSource !== 'ONLINE'">
        <miniapp-qrcode />
      </div>
    </page-result>
    <page-result
      v-else
      :image="imgError"
      title="支付失败"
      desc="无有效单证信息"
    >
    </page-result>
  </page-status>
</template>

<script>
import PageStatus from '@/components/PageStatus';
import PageResult from '@/components/PageResult';
import MiniappQrcode from '@/components/MiniappQrcode';
import imgSuccess from '@/assets/img-status-success.png';
import imgError from '@/assets/img-status-error.png';
import { bindRecord } from '@/core/recorder';

import * as services from '@/services';

export default {
  name: 'PaySuccess',
  components: {
    PageStatus,
    PageResult,
    MiniappQrcode,
  },
  data() {
    return {
      detail: {
        licenseNo: '',
        appliName: '',
        totalPremium: '',
        clauseVos: [],
      },
      loading: true,
      checked: false,
      showDialog: false,
      imgSuccess: imgSuccess,
      imgError: imgError,
      businessSource: '',
    };
  },

  created() {
    const { businessSource } = this.$route.query;
    this.businessSource = businessSource;
    const token =
      this.$route.query.authToken || window.localStorage.getItem('authToken');
    window.localStorage.setItem('authToken', token);
    this.fetchData();
  },
  methods: {
    fetchData() {
      const { businessNo, mobile } = this.$route.query;
      services
        .getProposal(businessNo, mobile)
        .then(res => {
          if (res.data) {
            this.detail = res.data.policyInfo;
            // 绑定业务编号
            if (businessNo) {
              bindRecord({ bizNo: businessNo, bizType: 'proposal' });
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="less">
.insure-result {
  height: 100%;

  .result-pay {
    margin: 16px;
    background-color: #ffffff;
    box-shadow: 0 4px 12px 0 rgba(118, 118, 118, 0.05);
    border-radius: 6px;

    .header {
      display: flex;
      align-items: center;
      padding: 8px 12px;
      font-size: 20px;

      .header-title {
        flex: 1;
        color: #4a4a4a;
        line-height: 40px;
        font-weight: 500;
      }

      .header-premium {
        color: #4294f5;
      }
    }

    .content {
      padding: 8px 12px;
      color: #9b9b9b;
      font-size: 14px;
      line-height: 1.5;
    }

    .split-line {
      position: relative;
      border-bottom: 1px dashed #eaeaea;
    }

    .split-line::before,
    .split-line::after {
      content: '';
      width: 10px;
      height: 10px;
      position: absolute;
      bottom: -5px;
      border-radius: 5px;
      background-color: #fafafa;
    }

    .split-line::before {
      left: -5px;
    }

    .split-line::after {
      right: -5px;
    }
  }
}
</style>
